import React from 'react';
import {Row} from 'react-table';
import {PreleadProject} from 'api';

interface Props {
  row: Row<PreleadProject>;
  value: any;
}

const isUrl = (str: string | null) => /^https?:\/\//.test(str);

const ProjectGroupCustomizeItemTextCell = ({row, value}: Props) => {
  const preleadProject: PreleadProject = row.original;
  const projectGroupPreleadCustomizeItemId = value;

  const customizeItem = React.useMemo(
    () =>
      preleadProject.prelead.projectGroupCustomizeItemTexts.find(
        (item) =>
          item.projectGroupPreleadCustomizeItemId ===
          projectGroupPreleadCustomizeItemId,
      ),
    [preleadProject, projectGroupPreleadCustomizeItemId],
  );

  return isUrl(customizeItem?.value) ? (
    <a href={customizeItem.value} target="_blank">
      {customizeItem.value}
    </a>
  ) : (
    customizeItem?.value || null
  );
};

export default ProjectGroupCustomizeItemTextCell;
